module.exports = __webpack_public_path__ + "media/Bloody Resistance.071460e0.mp3";